import React from 'react';
import PropTypes from 'prop-types';

import TableSectionContext from './TableSectionContext';

const TableHead = ({ children }) => {
  return (
    <TableSectionContext.Provider value="head">
      <thead>{children}</thead>
    </TableSectionContext.Provider>
  );
};

TableHead.propTypes = {
  children: PropTypes.node
};

TableHead.defaultProps = {
  children: undefined
};

export default TableHead;
